import * as React from "react";

import Layout from "../components/layout/layout";
import Cookies from "../components/privacy_policies/cookies";
import Seo from "../components/seo";
import { useTranslation } from 'react-i18next';

const PolitiqueDeCookies = () => {
  const {t} = useTranslation();
  return (
    <>
      <Seo
        title={t('cookie_policy_title')}
        description="Politique De Cookies."
      />
      <Layout>
        <Cookies />
      </Layout>
    </>
  )
}

export default PolitiqueDeCookies;
